module.exports = __webpack_public_path__ + "static/media/twitter.aab6663c.svg";